<div class="widget-settings_box">
    <div class="widget-settings_header">
        <div class="widget-settings_header_title" (click)="close()">
            <svg class="chevron">
                <use xlink:href="#chevron-down"></use>
            </svg>{{"components.dashboard.widget_settings_title" | l10n}}
        </div>
    </div>
    <div class="widget-settings_scroll-container" scrollbarWithEndingBlinds>
        <div class="widget-settings_body" elementRuler #contentBodyEl>
            <widget-settings-body-renderer [widget]="widget()"></widget-settings-body-renderer>
        </div>
    </div>
</div>
